function BurkinaFaso({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_806)">
  <path d="M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16C31.3044 16 16 18.0869 16 18.0869L0 16Z" fill="#D80027"/>
  <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16" fill="#6DA544"/>
  <path d="M15.9999 10.4346L17.2085 14.1544H21.1202L17.9557 16.4536L19.1643 20.1737L15.9999 17.8746L12.8355 20.1737L14.0443 16.4536L10.8798 14.1544H14.7913L15.9999 10.4346Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default BurkinaFaso;
